<template>
  <v-btn icon @click="openConfigModal">
    <v-icon>mdi-cogs</v-icon>
  </v-btn>
</template>

<script>
export default {
  methods: {
    openConfigModal() {
      this.$emit("open-config-modal");
    },
  },
};
</script>
